import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, AlertProps, styled } from '@mui/material';
import React from 'react';

const StyledAlert = styled(Alert)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark' ? theme.palette.background.default : theme.palette.grey[100],
  color: theme.palette.text.secondary,
  '& .MuiAlert-icon': {
    color: theme.palette.text.secondary,
  },
}));

export const MutedAlert = React.forwardRef<HTMLDivElement, AlertProps>(
  ({ icon = <InfoOutlinedIcon />, ...props }, ref) => {
    return <StyledAlert ref={ref} icon={icon} {...props} />;
  },
);

MutedAlert.displayName = 'MutedAlert';
